import axios from 'axios';
import axiosRetry from 'axios-retry';
import createAuthRefreshInterceptor from 'axios-auth-refresh';
import { getCsrf, requestCsrf } from './auth';

import { API_URL } from '../config/environments';

axiosRetry(axios, { retries: 2 });

const api = axios.create({
  baseURL: API_URL
});

export const auth = axios.create({
  baseURL: API_URL
})

api.defaults.withCredentials = true;
auth.defaults.withCredentials = true;

api.interceptors.request.use(async config => {
  if (getCsrf()) config.headers.common['X-CSRF-Token'] = getCsrf();
  return config;
});

// Function that will be called to refresh authorization
const refreshAuthLogic = failedRequest =>
  requestCsrf().then(csrfRefreshResponse => {
    localStorage.setItem('csrf', csrfRefreshResponse.data.csrf);
    failedRequest.response.config.headers['X-CSRF-Token'] = csrfRefreshResponse.data.csrf;
    return Promise.resolve();
  });

// Instantiate the interceptor (you can chain it as it returns the axios instance)
createAuthRefreshInterceptor(api, refreshAuthLogic, { statusCodes: [403] });

export default api;
